import { DATASOURCE } from 'Constants'

const initialState = {
  count: [],
  totalCalls: 0,
  totalCountries: 0,
  totalCities: 0,
  uniqueCountries: 0,
  uniqueCities: 0,
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.GEOCOUNT.KEY:
      return {
        ...state,
        count:  parseData(action.data.buckets),
        totalCalls: action.data.hits,
        totalCountries: action.data.totalCountries,
        totalCities: action.data.totalCities,
        uniqueCountries: action.data.uniqueCountries,
        uniqueCities: action.data.uniqueCities,
        loading: false
      };
    case DATASOURCE.GEOCOUNT.LOADING:
      return {
        ...state,
        count: [],
        totalCalls: 0,
        totalCountries: 0,
        totalCities: 0,
        uniqueCountries: 0,
        uniqueCities: 0,
        loading: true
      };
    default:
      return state;
  }
};

let parseData = function(data) {
  let ret = [];
  // comes back as an array of objects with an object of key "3" inside
  data.forEach( datum => {
    if (!datum.hasOwnProperty("3")) {
      console.log("GeoCount error? Not indexed with '3': %O",datum);
      return;
    }
    let point = {};
    point.lat = datum["3"].location.lat;
    point.lon = datum["3"].location.lon;
    point.z = datum["3"].count;
    ret.push(point);
  });
  return ret;
};
